export default "__VITE_ASSET__DVoJCoKu__"